<script>
    export default {
        name: "CenterNavigationMenu",
        props: {
            menu: Array,
        },
        methods: {
            onClick(path) {
                if (path.includes("#")) {
                    const [, hash] = path.split("#");
                    this.$emit("on-click", hash);
                } else {
                    this.$emit("on-click");
                }
            },
            createPath(path) {
                const isAnchorMenu = path.includes("#");
                const isSlugMenu = path.includes("__");

                if (isAnchorMenu) {
                    const [name, link] = path.split("#");
                    return { name, hash: `#${link}` };
                }

                if (isSlugMenu) {
                    const [name, slug] = path.split("__");
                    return { name, params: { slug } };
                }

                return { name: path };
            },
        },
    };
</script>

<template>
    <div class="c-menu">
        <slot name="beforeLink"></slot>

        <router-link
            v-for="(item, id) in menu"
            :key="id"
            :to="createPath(item.link)"
            class="c-menu__link"
            :class="{ 'c-menu__link--hash': item.link.includes('#') }"
            @click.native="onClick(item.link)"
        >
            {{ item.name }}
        </router-link>

        <slot name="afterLink"></slot>
    </div>
</template>
